import React, { useEffect, useState, useCallback } from "react";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa"; // Import des icônes pour modifier et supprimer
import { CheckCircleIcon } from "@heroicons/react/solid";
import Select from "react-select";
import { v4 as uuidv4 } from "uuid";
import FichierExcel from "../components/FichierExcel";
import FichierExcelRh from "../components/FichierExcelRh";
import { apiFetch } from '../utils/apiClient';
const GestionDonneeFinance = ({
  checkGroupAdresse,
  checkGroupAdmin,
  checkGroupNom,
  checkGroupInfoBancaire,
  checkGroupAntCriminels,
  checkGroupRecMensuelle,
  checkGroupSeancePlacement,
  routesConfig,
  setRoutesConfig
}) => {
  const [natureDepenses, setNatureDepenses] = useState([]);
  const [centreCouts, setCentreCout] = useState([]);
  const [funds, setFunds] = useState([]);
  const [taux, setTaux] = useState([]);
  const [codesTaxe, setCodesTaxe] = useState([]);
  const [categories, setCategories] = useState([]);
  const [institutions, setInstitutions] = useState([]);

  const [selectedNatureDepense, setSelectedNatureDepense] = useState(null);
  const [selectedCentreCouts, setSelectedCentreCouts] = useState(null);
  const [selectedFunds, setSelectedFunds] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCodeTaxe, setSelectedCodeTaxe] = useState(null);
  const [selectedInstitution, setSelectedInstitution] = useState(null);

  const [nouveaucentreCouts, setNouveauCentreCout] = useState();
  const [compte, setCompte] = useState("");
  const [value, setValue] = useState("");
  const [nouveauFunds, setNouveauFunds] = useState();
  const [nouveauInstitution, setNouveauInstitution] = useState();

  const [dropdownError, setDropdownError] = useState("");
  const [dropdownErrorCout, setDropdownErrorCout] = useState("");
  const [dropdownErrorFunds, setDropdownErrorFunds] = useState("");
  const [dropdownErrorInstitution, setDropdownErrorInstitution] = useState("");

  const [inputFieldsError, setInputFieldsError] = useState("");
  const [inputFieldsErrorCout, setInputFieldsErrorCout] = useState("");
  const [inputFieldsErrorFunds, setInputFieldsErrorFunds] = useState("");
  const [inputFieldsErrorInstitution, setInputFieldsErrorInstitution] =
    useState("");

  const [successMessage, setSuccessMessage] = useState("");
  const [couleur, setcouleur] = useState("");
  const [openCards, setOpenCards] = useState({});

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // const [nouveauTaux, setNouveauTaux] = useState("");
  // const [dateDebut, setDateDebut] = useState(
  //   new Date(Date.now() + 86400000).toISOString().split("T")[0]
  // );

  const fetchData = async (endpoint, setter) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/${endpoint}`
      );
      const data = await response.json();
      setter(data);
    } catch (error) {
      console.error(`Error fetching ${endpoint}:`, error);
    }
  };

  const fetchAll = useCallback(() => {
    fetchData("NatureDepense", setNatureDepenses);
    fetchData("CentreCout", setCentreCout);
    fetchData("Funds", setFunds);
    fetchData("TauxKilometrage", setTaux);
    fetchData("categorySchema", setCategories);
    fetchData("codeTaxeSchema", setCodesTaxe);
    fetchData("institution", setInstitutions);
  }, []); // Ajoute ici des dépendances si besoin

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  const handleSelectChange = (selectedOption) => {
    setDropdownError("");
    if (!selectedOption) {
      // When cleared
      setSelectedNatureDepense(null);
      setCompte("");
      setValue("");
      setSelectedCategory(null);
      setSelectedCodeTaxe(null);
      return;
    }

    const selectedDepense = natureDepenses.find(
      (depense) => depense._id === selectedOption.value
    );

    if (selectedDepense) {
      setSelectedNatureDepense(selectedDepense);
      setCompte(selectedDepense.compte);
      setValue(selectedDepense.value);
      // Mettre la catégorie sélectionnée
      setSelectedCategory({
        value: selectedDepense.categories,
        label: selectedDepense.categories,
      });

      // Mettre le code de taxe sélectionné
      setSelectedCodeTaxe({
        value: selectedDepense.codeTaxe,
        label: selectedDepense.codeTaxe,
      });
    }
  };

  const handleSelectChangeInstitution = (selectedOption) => {
    setDropdownErrorInstitution("");
    if (!selectedOption) {
      // When cleared
      setSelectedInstitution(null);
      setNouveauInstitution("");
      return;
    }
    const selectedInstitution = institutions.find(
      (institution) => institution._id === selectedOption.value
    );
    if (selectedInstitution) {
      setSelectedInstitution(selectedInstitution); // ✅ ici !
      setNouveauInstitution(selectedInstitution.name);
    }
  };

  const handleSelectChangeCentreCout = (e) => {
    setDropdownErrorCout("");
    const selectedId = e.target.value;
    if (!selectedId) {
      // When cleared
      setSelectedCentreCouts(null);
      setNouveauCentreCout("");
      return;
    }
    const selectedDepense = centreCouts.find(
      (depense) => depense._id === selectedId
    );
    if (selectedDepense) {
      setSelectedCentreCouts(selectedDepense); // ✅ ici !
      setNouveauCentreCout(selectedDepense.value);
    }
  };

  const handleSelectChangeFunds = (e) => {
    setDropdownErrorFunds("");
    const selectedId = e.target.value;
    if (!selectedId) {
      // When cleared
      setSelectedFunds(null);
      setNouveauFunds("");
      return;
    }
    const selectedFunds = funds.find((fund) => fund._id === selectedId);
    if (selectedFunds) {
      setSelectedFunds(selectedFunds); // ✅ ici !
      setNouveauFunds(selectedFunds.value);
    }
  };

  const reinitialisation = () => {
    // Réinitialise le message d'erreur
    setDropdownError("");
    setDropdownErrorCout("");
    setDropdownErrorFunds("");
    setDropdownErrorInstitution("");

    setInputFieldsError("");
    setInputFieldsErrorCout("");
    setInputFieldsErrorFunds("");
    setInputFieldsErrorInstitution("");

    setCompte("");
    setValue("");
    setNouveauCentreCout("");
    setNouveauFunds("");
    setNouveauInstitution("");
    setSelectedCategory(null);
    setSelectedCodeTaxe(null);

    setSelectedInstitution(null);

    setSelectedNatureDepense(null);
    setSelectedCentreCouts(null);
    setSelectedFunds(null);

    fetchAll();
  };

  const handleEdit = async (field) => {
    if (field === "Nature de dépense") {
      if (!selectedNatureDepense) {
        setDropdownError("Veuillez sélectionner une nature de dépense.");
        return;
      }
      if (!selectedCategory) {
        setDropdownError("Veuillez sélectionner une catégorie.");
        return;
      }

      if (!selectedCodeTaxe) {
        setDropdownError("Veuillez sélectionner un code de taxe.");
        return;
      }
      if (!compte) {
        setDropdownError("Veuillez saisir un numéro de compte.");
        return;
      }
      // Empêcher la duplication de `value` par un autre élément
      const isValueUsedByAnother = natureDepenses.some(
        (depense) =>
          depense.value === value && depense._id !== selectedNatureDepense._id
      );

      if (isValueUsedByAnother) {
        setInputFieldsError(
          "Cette valeur est déjà utilisée par une autre nature de dépense."
        );
        return;
      }
    } else if (field === "Centre de cout") {
      if (!selectedCentreCouts) {
        setDropdownErrorCout("Veuillez sélectionner un centre de coût");
        return;
      }
      // Empêcher la duplication de `value` par un autre élément
      const isValueUsedByAnother = centreCouts.some(
        (centreCout) =>
          Number(centreCout.value) === Number(nouveaucentreCouts) &&
          centreCout._id !== selectedCentreCouts._id
      );

      if (isValueUsedByAnother) {
        setInputFieldsErrorCout("Cette valeur est déjà utilisée");
        return;
      }
    } else if (field === "Institution") {
      console.log();
      if (!selectedInstitution) {
        setDropdownErrorInstitution("Veuillez sélectionner une institution");
        return;
      }
      const isValueUsedByAnother = institutions.some(
        (institution) =>
          institution.name === nouveauInstitution &&
          institution._id !== selectedInstitution._id
      );

      if (isValueUsedByAnother) {
        setInputFieldsErrorInstitution("Cette valeur est déjà utilisée");
        return;
      }
    } else {
      if (!selectedFunds) {
        setDropdownErrorFunds("Veuillez sélectionner un fonds");
        return;
      }
      // Empêcher la duplication de `value` par un autre élément
      const isValueUsedByAnother = funds.some(
        (fund) =>
          Number(fund.value) === Number(nouveauFunds) &&
          fund._id !== selectedFunds._id
      );

      if (isValueUsedByAnother) {
        setInputFieldsErrorFunds("Cette valeur est déjà utilisée");
        return;
      }
    }

    try {
      let nom = "";
      let id = "";
      const data = {};
      if (field === "Nature de dépense") {
        nom = "NatureDepense";
        id = selectedNatureDepense._id;
        data.value = value;
        data.compte = compte;
        data.categories = selectedCategory.label;
        data.codeTaxe = selectedCodeTaxe.label;
      } else if (field === "Centre de cout") {
        nom = "CentreCout";
        id = selectedCentreCouts._id;
        data.value = nouveaucentreCouts;
      } else if (field === "Institution") {
        nom = "Institution";
        id = selectedInstitution._id;
        data.value = nouveauInstitution;
      } else {
        nom = "Funds";
        id = selectedFunds._id;
        data.value = nouveauFunds;
      }
      const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/gestionFinance/${nom}/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error("Erreur lors de la mise à jour.");
      }

      // const updated = await response.json();

      reinitialisation();
      setSuccessMessage(`${field} a été modifiée avec succès.`);
      setcouleur("text-blue-600");
      // Effacer le message après 3 secondes
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    } catch (error) {
      console.error("Erreur :", error);
      alert("Une erreur est survenue lors de la mise à jour.");
    }
  };

  const handleDelete = async (field) => {
    if (field === "Nature de dépense") {
      if (!selectedNatureDepense) {
        setDropdownError(
          "Veuillez sélectionner une nature de dépense à supprimer."
        );
        return;
      }
    } else if (field === "Centre de cout") {
      if (!selectedCentreCouts) {
        setDropdownErrorCout(
          "Veuillez sélectionner un centre de coût à supprimer."
        );
        return;
      }
    } else if (field === "Institution") {
      if (!selectedInstitution) {
        setDropdownErrorInstitution(
          "Veuillez sélectionner une Institution à supprimer."
        );
        return;
      }
    } else {
      if (!selectedFunds) {
        setDropdownErrorFunds("Veuillez sélectionner un Fonds à supprimer.");
        return;
      }
    }

    try {
      let nom = "";
      let id = "";
      if (field === "Nature de dépense") {
        nom = "NatureDepense";
        id = selectedNatureDepense._id;
      } else if (field === "Centre de cout") {
        nom = "CentreCout";
        id = selectedCentreCouts._id;
      } else if (field === "Institution") {
        nom = "Institution";
        id = selectedInstitution._id;
      } else {
        nom = "Funds";
        id = selectedFunds._id;
      }
      const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/gestionFinance/${nom}/${id}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        reinitialisation();
        setcouleur("text-red-600");
        setSuccessMessage(`${field} a été supprimée avec succès.`);
        setTimeout(() => setSuccessMessage(""), 3000);
      } else {
        alert("Erreur lors de la suppression.");
      }
    } catch (error) {
      console.error("Erreur lors de la suppression:", error);
      alert("Une erreur est survenue.");
    }
  };

  const handleAdd = async (field) => {
    if (field === "Nature de dépense") {
      if (!value || !compte) {
        setInputFieldsError(
          "Veuillez remplir les champs 'Compte' et 'Valeur'."
        );
        return;
      }
      if (!selectedCategory || !selectedCategory.label) {
        setInputFieldsError("Veuillez sélectionner une catégorie.");
        return;
      }

      if (!selectedCodeTaxe || !selectedCodeTaxe.label) {
        setInputFieldsError("Veuillez sélectionner un code de taxe.");
        return;
      }

      // Vérifier si le compte existe déjà dans la liste
      const isCompteExist = natureDepenses.some(
        (depense) => depense.value === value
      );

      if (isCompteExist) {
        setInputFieldsError("Ce compte existe déjà.");
        return;
      }
    } else if (field === "Centre de cout") {
      if (!nouveaucentreCouts) {
        setInputFieldsErrorCout("Veuillez remplir le champ centre de cout.");
        return;
      }
      // Vérifier si le compte existe déjà dans la liste
      const isCompteExist = centreCouts.some(
        (centreCout) => Number(centreCout.value) === Number(nouveaucentreCouts)
      );

      if (isCompteExist) {
        setInputFieldsErrorCout("Ce compte existe déjà.");
        return;
      }
    } else if (field === "Institution") {
      if (!nouveauInstitution) {
        setInputFieldsErrorInstitution(
          "Veuillez remplir le champ institution."
        );
        return;
      }

      // Vérifier si le compte existe déjà dans la liste
      const isCompteExist = institutions.some(
        (institution) => institution.name === nouveauInstitution
      );

      if (isCompteExist) {
        setInputFieldsErrorInstitution("Cette institution existe déjà.");
        return;
      }
    } else {
      if (!nouveauFunds) {
        setInputFieldsErrorFunds("Veuillez remplir le champ Fonds.");
        return;
      }
      // Vérifier si le compte existe déjà dans la liste
      const isCompteExist = funds.some(
        (fund) => Number(fund.value) === Number(nouveauFunds)
      );

      if (isCompteExist) {
        setInputFieldsErrorFunds("Ce compte existe déjà.");
        return;
      }
    }

    try {
      let nom = "";
      const data = {};
      if (field === "Nature de dépense") {
        nom = "NatureDepense";
        data.value = value;
        data.compte = compte;
        data.categories = selectedCategory.label;
        data.codeTaxe = selectedCodeTaxe.label;
      } else if (field === "Centre de cout") {
        nom = "CentreCout";
        data.value = nouveaucentreCouts;
      } else if (field === "Institution") {
        nom = "Institution";
        data.value = nouveauInstitution;
      } else {
        nom = "Funds";
        data.value = nouveauFunds;
      }
      const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/gestionFinance/${nom}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.error || "Erreur lors de l'ajout.");
      }

      // const newNatureDepense = await response.json();

      reinitialisation();
      setcouleur("text-green-600");
      setSuccessMessage(`${field} a été ajoutée avec succès.`);
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (err) {
      console.error("Erreur lors de l'ajout :", err);
      alert(err.message || "Erreur inconnue.");
    }
  };

  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({
    value: "",
    Datedebut: "",
    DatedeFin: "",
  });

  const handleEditTable = (t) => {
    setEditId(t._id);
    setEditData({
      value: t.value,
      Datedebut: t.Datedebut
        ? new Date(t.Datedebut).toISOString().split("T")[0]
        : "",
      DatedeFin: t.DatedeFin
        ? new Date(t.DatedeFin).toISOString().split("T")[0]
        : "",
    });
  };

  const handleChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleSave = async (id) => {
    const isNew = id.startsWith("new-");
    const newDateDebut = new Date(editData.Datedebut);
    let updatedPreviousRow = null;

    // 🔒 VALIDATION COMMUNE
    if (!editData.value || !editData.Datedebut) {
      alert("Veuillez remplir le taux et la date de début.");
      return;
    }

    // 🔒 VALIDATION POUR LA MODIFICATION (DatedeFin requis si ce n’est pas 'en cours')
    if (
      !isNew &&
      taux.find((t) => t._id === id)?.DatedeFin !== null &&
      !editData.DatedeFin
    ) {
      alert(
        "Veuillez fournir la date de fin ou laisser le champ vide pour indiquer que c'est en cours."
      );
      return;
    }

    if (isNew) {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/TauxKilometrage`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            value: editData.value,
            Datedebut: editData.Datedebut,
            DatedeFin: editData.DatedeFin || null,
          }),
        }
      );
      const newItem = await response.json();

      // Trouver la ligne précédente
      const previous = [...taux]
        .filter(
          (t) =>
            !t._id.startsWith("new-") &&
            t.Datedebut &&
            new Date(t.Datedebut) < newDateDebut
        )
        .sort((a, b) => new Date(b.Datedebut) - new Date(a.Datedebut))[0];

      if (previous) {
        const veille = new Date(newDateDebut);
        veille.setDate(veille.getDate() - 1);

        await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/TauxKilometrage/${previous._id}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              ...previous,
              DatedeFin: veille.toISOString().split("T")[0],
            }),
          }
        );

        updatedPreviousRow = {
          ...previous,
          DatedeFin: veille.toISOString().split("T")[0],
        };
      }

      setTaux((prev) =>
        [
          ...prev.filter(
            (t) => t._id !== id && t._id !== updatedPreviousRow?._id
          ),
          ...(updatedPreviousRow ? [updatedPreviousRow] : []),
          newItem,
        ].sort((a, b) => new Date(a.Datedebut) - new Date(b.Datedebut))
      );
    } else {
      // Mise à jour d’un existant
      await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/TauxKilometrage/${id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            value: editData.value,
            Datedebut: editData.Datedebut,
            DatedeFin: editData.DatedeFin || null,
          }),
        }
      );

      setTaux((prev) =>
        prev.map((t) =>
          t._id === id
            ? {
              ...t,
              value: editData.value,
              Datedebut: editData.Datedebut,
              DatedeFin: editData.DatedeFin || null,
            }
            : t
        )
      );
    }

    setEditId(null);
  };

  const handleCancel = (id) => {
    const isNew = id.startsWith("new-");
    if (isNew) {
      setTaux(taux.filter((t) => t._id !== id));
    }
    setEditId(null);
  };

  const handleDeleteTable = async (id) => {
    const confirmDelete = window.confirm(
      "Es-tu sûr de vouloir supprimer cet élément ?"
    );
    if (!confirmDelete) return;

    try {
      if (!id.startsWith("new-")) {
        // console.log(id)
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/TauxKilometrage/${id}`,
          {
            method: "DELETE",
          }
        );

        if (!response.ok) {
          throw new Error("La suppression a échoué sur le serveur.");
        }
      }

      setTaux((prev) => prev.filter((t) => t._id !== id));
    } catch (error) {
      console.error("Erreur lors de la suppression :", error);
      alert("Une erreur est survenue lors de la suppression.");
    }
  };

  const handleAddTable = () => {
    const newRow = {
      _id: `new-${uuidv4()}`,
      value: "",
      Datedebut: "",
      DatedeFin: "",
    };
    setTaux([newRow, ...taux]);
    setEditId(newRow._id);
    setEditData({
      value: "",
      Datedebut: "",
      DatedeFin: "",
    });
  };

  const toggleRoute = async (route) => {
    // basculer enabled en local
    const updated = { ...route, enabled: !route.enabled };

    setRoutesConfig(prev =>
      prev.map(r =>
        r.path === route.path ? updated : r
      )
    );

    try {
      // envoyer la mise à jour au backend
      await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/routeUpdate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          path: updated.path,
          enabled: updated.enabled,
          startDate: null,
          endDate: null, // ici on efface volontairement
          // label: updated.label,
          // description: updated.description, 
        }),
      });
    } catch (err) {
      console.error("Erreur lors de la mise à jour :", err);
    }
  };
  const handleDateChange = (route, field, value) => {
    setRoutesConfig(prev =>
      prev.map(r =>
        r.path === route.path ? { ...r, [field]: value } : r
      )
    );
  };

  const handleDescriptionChange = (routeConfig, value) => {
    setRoutesConfig(prev =>
      prev.map(r =>
        r.path === routeConfig.path ? { ...r, description: value } : r
      )
    );
  };

  // const handleValidate = async (routeConfig, fieldsToUpdate) => {
  //   try {
  //     // 🔥 CLEAN OBJECT (THIS IS THE FIX)
  //     const cleanedFields = {};
  //     Object.keys(fieldsToUpdate).forEach((key) => {
  //       const value = fieldsToUpdate[key];
  //       if (value !== undefined && value !== "" && value !== null) {
  //         cleanedFields[key] = value;
  //       }
  //     });

  //     // 🚫 nothing to save
  //     if (Object.keys(cleanedFields).length === 0) return;

  //     await apiFetch(
  //       `${process.env.REACT_APP_API_BASE_URL}/routeUpdate`,
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           path: routeConfig.path,
  //           ...cleanedFields,
  //         }),
  //       }
  //     );
  //     setSuccessMessage("Données sauvegardées !");
  //     setcouleur("text-green-600");
  //     setTimeout(() => setSuccessMessage(""), 3000);

  //   } catch (error) {
  //     console.error("Erreur sauvegarde :", error);
  //   }
  // };

  const localToUTC = (localDateTime) => {
    // "2026-02-03T15:35"
    const [date, time] = localDateTime.split("T");
    const [year, month, day] = date.split("-").map(Number);
    const [hour, minute] = time.split(":").map(Number);

    // 👇 crée une Date LOCALE (Toronto)
    const localDate = new Date(year, month - 1, day, hour, minute);

    return localDate.toISOString(); // UTC réel
  };
  const handleValidate = async (routeConfig, fieldsToUpdate) => {
    try {
      const cleanedFields = {};

      Object.keys(fieldsToUpdate).forEach((key) => {
        const value = fieldsToUpdate[key];

        if (value !== undefined && value !== "" && value !== null) {
          if (key === "startDate" || key === "endDate") {
            cleanedFields[key] = localToUTC(value); // 👈 conversion ici
          } else {
            cleanedFields[key] = value;
          }
        }
      });

      if (Object.keys(cleanedFields).length === 0) return;

      await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/routeUpdate`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            path: routeConfig.path,
            ...cleanedFields,
          }),
        }
      );

      setSuccessMessage("Données sauvegardées !");
      setcouleur("text-green-600");
      setTimeout(() => setSuccessMessage(""), 3000);

    } catch (error) {
      console.error("Erreur sauvegarde :", error);
    }
  };


  // const handleValidate = async (routeConfig) => {
  //   try {
  //     await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/routeUpdate`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         path: routeConfig.path,
  //         label: routeConfig.label,
  //         enabled: routeConfig.enabled,
  //         startDate: routeConfig.startDate || null,
  //         endDate: routeConfig.endDate || null,
  //         description: routeConfig.description || null,
  //       }),
  //     });

  //     setSuccessMessage(`Données sauvegardées !`);
  //       setcouleur("text-green-600");
  //       // Effacer le message après 3 secondes
  //       setTimeout(() => {
  //         setSuccessMessage("");
  //       }, 3000);

  //   } catch (error) {
  //     console.error("Erreur lors de la mise à jour :", error);
  //   }
  // };

  const formatDateTimeLocal = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const toggleCard = (path) => {
    setOpenCards(prev => ({
      ...prev,
      [path]: !prev[path],
    }));
  };



  const syncPersonnel = async (type) => {
    try {
      const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/sync-personnel`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ type }),
        }
      );

      if (!response.ok) {
        throw new Error("Sync failed");
      }

      const result = await response.json();

      setcouleur("text-green-600");
      setSuccessMessage(
        `✅ ${type} synchronisé (${result.lignesImportees} lignes)`
      );
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (err) {
      console.error(err);
      alert(`❌ Erreur lors de la synchronisation ${type}`);
    }
  };

  return (
    <div className="min-h-screen p-4">
      <div className="w-full flex justify-center mt-6 mb-20">
        <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-md shadow-md w-fit">
          <h1 className="text-xl font-bold flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
              />
            </svg>
            Console d'administration
          </h1>
        </div>
      </div>

      {(checkGroupAdmin || checkGroupSeancePlacement) && (
        <div className="mb-10">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-semibold text-gray-800 flex items-center gap-2">
              <span className="text-blue-500">⚙️</span> Séance de placement
            </h2>
            <span className="text-sm text-gray-500">
              {routesConfig.filter(r => ["Form AEFO", "Form FEESO", "Form SCFP"].includes(r.label)).length} route(s) disponible(s)
            </span>
          </div>

          {/* Routes */}
          <div className="space-y-6">
            {routesConfig
              .filter(route => ["Form AEFO", "Form FEESO", "Form SCFP"].includes(route.label))
              .map(route => {
                const isOpen = openCards[route.path];

                return (
                  <div
                    key={route.path}
                    className="bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 space-y-6"
                  >
                    {/* Header: label + toggle */}
                    <div className="flex items-center justify-between p-6">
                      <div className="flex items-center gap-3">
                        {/* Toggle icon */}
                        <button
                          onClick={() => toggleCard(route.path)}
                          className="text-gray-500 hover:text-gray-700 transition text-xl font-bold"
                        >
                          {isOpen ? "−" : "+"}
                        </button>

                        <div>
                          <h3 className="text-lg font-semibold text-gray-800">{route.label}</h3>
                          <p className="text-xs text-gray-500 mt-1">{route.path}</p>
                        </div>
                      </div>

                      <button
                        onClick={() => toggleRoute(route)}
                        className={`px-5 py-1.5 rounded-full text-sm font-medium transition-all duration-300 ${route.enabled
                            ? "bg-green-500 hover:bg-green-600 text-white shadow"
                            : "bg-red-500 hover:bg-red-600 text-white shadow"
                          }`}
                      >
                        {route.enabled ? "Activé" : "Désactivé"}
                      </button>
                    </div>

                    {/* Contenu collapsible */}
                    {isOpen && (
                      <div className="px-6 pb-6 space-y-6">
                        {/* Dates */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm text-gray-600 mb-1">Date d’activation</label>
                            <input
                              type="datetime-local"
                              value={formatDateTimeLocal(route.startDate)}
                              onChange={e => handleDateChange(route, "startDate", e.target.value)}
                              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                          </div>
                          <div>
                            <label className="block text-sm text-gray-600 mb-1">Date de désactivation</label>
                            <input
                              type="datetime-local"
                              value={formatDateTimeLocal(route.endDate)}
                              onChange={e => handleDateChange(route, "endDate", e.target.value)}
                              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                          </div>
                        </div>

                        <div className="flex justify-start">
                          <button
                            onClick={() => handleValidate(route, { startDate: route.startDate, endDate: route.endDate })}
                            className="mt-4 px-5 py-2 bg-green-500 hover:bg-green-600 text-white text-sm font-medium rounded-lg shadow transition-all"
                          >
                            Sauvegarder
                          </button>
                        </div>

                        {/* Description */}
                        <div>
                          <label className="block text-sm text-gray-600 mb-1">Description</label>
                          <textarea
                            rows={5}
                            value={route.description || ""}
                            onChange={e => handleDescriptionChange(route, e.target.value)}
                            placeholder="Écrire une description détaillée..."
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 resize-y"
                          />
                          <div className="flex justify-start">
                            <button
                              onClick={() => handleValidate(route, { description: route.description })}
                              className="mt-4 px-5 py-2 bg-green-500 hover:bg-green-600 text-white text-sm font-medium rounded-lg shadow transition-all"
                            >
                              Sauvegarder
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
          {/* <div className="space-y-6">
    {routesConfig
      .filter(route => ["Form AEFO", "Form FEESO", "Form SCFP"].includes(route.label))
      .map(route => (
        <div key={route.path} className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-md transition-all duration-300 space-y-6">
          
          
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-gray-800">{route.label}</h3>
              <p className="text-xs text-gray-500 mt-1">{route.path}</p>
            </div>
            <button
              onClick={() => toggleRoute(route)}
              className={`px-5 py-1.5 rounded-full text-sm font-medium transition-all duration-300 ${route.enabled
                  ? "bg-green-500 hover:bg-green-600 text-white shadow"
                  : "bg-red-500 hover:bg-red-600 text-white shadow"
                }`}
            >
              {route.enabled ? "Activé" : "Désactivé"}
            </button>
          </div>

         
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-gray-600 mb-1">Date d’activation</label>
              <input
                type="datetime-local"
                value={formatDateTimeLocal(route.startDate)}
                onChange={e => handleDateChange(route, "startDate", e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-600 mb-1">Date de désactivation</label>
              <input
                type="datetime-local"
                value={formatDateTimeLocal(route.endDate)}
                onChange={e => handleDateChange(route, "endDate", e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
          </div>
          <div className="flex justify-start">
            <button
              onClick={() => handleValidate(route, { startDate: route.startDate, endDate: route.endDate })}
              className="mt-4 px-5 py-2 bg-green-500 hover:bg-green-600 text-white text-sm font-medium rounded-lg shadow transition-all"
            >
              Sauvegarder
            </button>
          </div>

          
          <div>
            <label className="block text-sm text-gray-600 mb-1">Description</label>
            <textarea
              rows={5}
              value={route.description || ""}
              onChange={e => handleDescriptionChange(route, e.target.value)}
              placeholder="Écrire une description détaillée..."
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 resize-y"
            />
            <div className="flex justify-start">
              <button
                onClick={() => handleValidate(route, { description: route.description })}
                className="mt-4 px-5 py-2 bg-green-500 hover:bg-green-600 text-white text-sm font-medium rounded-lg shadow transition-all"
              >
                Sauvegarder
              </button>
            </div>
          </div>

        </div>
      ))}
  </div> */}
        </div>
      )}




      {(checkGroupAdresse ||
        checkGroupNom ||
        checkGroupAdmin ||
        checkGroupInfoBancaire ||
        checkGroupAntCriminels ||
        checkGroupSeancePlacement) && (
          <div className="rounded-xl shadow-md bg-white p-6 w-full mb-8">
            {/* Header */}
            <div className="flex items-center gap-3 mb-4">
              <span className="text-2xl animate-bounce">💾</span>
              <h2 className="text-xl font-bold text-gray-800">
                Générer les fichiers Excel
              </h2>
            </div>

            {/* Body */}
            <div className="space-y-6">
              {(checkGroupAdresse || checkGroupAdmin) && (
                <div className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition w-full ">
                  <FichierExcelRh nomformulaire={"Changement adresse"} />
                </div>
              )}

              {(checkGroupNom || checkGroupAdmin) && (
                <div className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition w-full ">
                  <FichierExcelRh nomformulaire={"Changement de nom"} />
                </div>
              )}

              {(checkGroupAdmin || checkGroupInfoBancaire) && (
                <div className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition w-full ">
                  <FichierExcelRh
                    nomformulaire={"Changement information bancaire"}
                  />
                </div>
              )}

              {(checkGroupAdmin || checkGroupAntCriminels) && (
                <div className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition w-full">
                  <FichierExcelRh nomformulaire={"Déclaration annuelle"} />
                </div>
              )}

              {(checkGroupAdmin || checkGroupSeancePlacement || checkGroupAntCriminels) && (

                <div className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition w-full">

                  {/* 🟦 TITRE AEFO */}
                  {/* <h3 className="text-lg font-semibold mb-4">Formulaires Séance de placement</h3> */}
                  {/* 🔥 Ajout des 2 champs de date ici */}
                  <div className="flex gap-4 mb-4">
                    <input
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="border p-2 rounded-md"
                    />

                    <input
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      className="border p-2 rounded-md"
                    />
                  </div>

                  {/* Afficher FichierExcelRh seulement si les 2 dates sont remplies */}
                  {/* ✅ ESPACE ENTRE LES DEUX BOUTONS */}

                  <div className="space-y-3">
                    {(checkGroupAdmin || checkGroupSeancePlacement ) && (
                      <>
                    <FichierExcelRh
                      nomformulaire="AEFO"
                      startDate={startDate}
                      endDate={endDate}
                    />

                    <FichierExcelRh
                      nomformulaire="FEESO"
                      startDate={startDate}
                      endDate={endDate}
                    />
                    
                    <FichierExcelRh
                      nomformulaire="SCFP"
                      startDate={startDate}
                      endDate={endDate}
                    />

                    </>
                    )}

                    {(checkGroupAdmin || checkGroupAntCriminels) && (
                      <>
                    <FichierExcelRh
                      nomformulaire="rapport de police"
                      startDate={startDate}
                      endDate={endDate}
                    />
                    </>
                    )}
                  </div>
                  
                </div>
              )}


              {/* 🔄 SYNCHRONISATION FEESO */}

              {(checkGroupAdmin || checkGroupSeancePlacement || checkGroupAntCriminels) && (
                <div className="mt-6 w-full rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">

                  {/* Titre */}
                  <div className="mb-4 flex items-center gap-2">
                    <span className="text-blue-600 text-lg">🔄</span>
                    <h4 className="text-base font-semibold text-gray-800">
                      Synchronisation du personnel
                    </h4>
                  </div>

                  {/* Description */}
                  <p className="mb-5 text-sm text-gray-500">
                    Synchroniser la liste du personnel depuis SharePoint selon le syndicat.
                  </p>

                  {/* Actions */}
                  {(checkGroupAdmin || checkGroupSeancePlacement) && (
                  <div className="flex flex-col gap-3 w-80">
                    {[
                      { label: "FEESO", value: "FEESO" },
                      { label: "AEFO", value: "AEFO" },
                      { label: "SCFP", value: "SCFP" },
                    ].map((item) => (
                      <button
                        key={item.value}
                        onClick={() => syncPersonnel(item.value)}
                        className="
          flex items-center justify-center gap-2
          rounded-xl border border-blue-100
          bg-blue-600 px-4 py-2.5
          text-sm font-medium text-white
          transition
          hover:bg-blue-300 hover:border-blue-200
          focus:outline-none focus:ring-2 focus:ring-blue-400
        "
                      >
                        🔄 Synchroniser {item.label}
                      </button>
                    ))}
                  </div>)}

                  {(checkGroupAdmin || checkGroupAntCriminels) && (
                  <div className="flex flex-col w-80 pt-3">
                   
                      <button
                        onClick={async() => {
                           try {
                                const response = await apiFetch(
                                  `${process.env.REACT_APP_API_BASE_URL}/sync-personnel-DecA`,
                                  {
                                    method: "POST",
                                    headers: { "Content-Type": "application/json" },
                                  }
                                );

                                if (!response.ok) {
                                  throw new Error("Sync failed");
                                }

                                const result = await response.json();

                                setcouleur("text-green-600");
                                setSuccessMessage(
                                  `✅ Déclaration annuelle synchronisé (${result.lignesImportees} lignes)`
                                );
                                setTimeout(() => setSuccessMessage(""), 3000);
                              } catch (err) {
                                console.error(err);
                                alert(`❌ Erreur lors de la synchronisation Déclaration Annuelle`);
                              }
                        }}
                        className="
                          flex items-center justify-center gap-2
                          rounded-xl border border-blue-100
                          bg-blue-600 px-4 py-2.5
                          text-sm font-medium text-white
                          transition
                          hover:bg-blue-300 hover:border-blue-200
                          focus:outline-none focus:ring-2 focus:ring-blue-400
                        "
                      >
                        🔄 Synchroniser Déclaration Annuelle
                      </button>
                  </div>)}

                </div>
              )}



              {(checkGroupAdmin) && (
                <div className="mt-6 w-full rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">

                  {/* Titre */}
                  <div className="mb-4 flex items-center gap-2">
                    <span className="text-blue-600 text-lg">🔄</span>
                    <h4 className="text-base font-semibold text-gray-800">
                      Synchronisation du fichier d'achat d'équipement Informatique
                    </h4>
                  </div>

                  {/* Description */}
                  <p className="mb-5 text-sm text-gray-500">
                    Synchroniser la liste du fichier d'achat d'équipement Informatique depuis SharePoint.
                  </p>

                  {(checkGroupAdmin || checkGroupAntCriminels) && (
                  <div className="flex flex-col w-80 pt-3">
                   
                      <button
                        onClick={async() => {
                           try {
                                const response = await apiFetch(
                                  `${process.env.REACT_APP_API_BASE_URL}/sync-AchatEI`,
                                  {
                                    method: "POST",
                                    headers: { "Content-Type": "application/json" },
                                  }
                                );

                                if (!response.ok) {
                                  throw new Error("Sync failed");
                                }

                                const result = await response.json();

                                setcouleur("text-green-600");
                                setSuccessMessage(
                                  `✅ Déclaration annuelle synchronisé (${result.lignesImportees} lignes)`
                                );
                                setTimeout(() => setSuccessMessage(""), 3000);
                              } catch (err) {
                                console.error(err);
                                alert(`❌ Erreur lors de la synchronisation Déclaration Annuelle`);
                              }
                        }}
                        className="
                          flex items-center justify-center gap-2
                          rounded-xl border border-blue-100
                          bg-blue-600 px-4 py-2.5
                          text-sm font-medium text-white
                          transition
                          hover:bg-blue-300 hover:border-blue-200
                          focus:outline-none focus:ring-2 focus:ring-blue-400
                        "
                      >
                        🔄 Synchroniser Achat d'équipement Informatique
                      </button>
                  </div>)}

                </div>
              )}
            </div>
          </div>
        )}

      {(checkGroupAdmin || checkGroupInfoBancaire) && (
        <div className="rounded-xl shadow-md border border-gray-200 mb-8">
          {/* Header */}
          <div className="flex items-center justify-between bg-gradient-to-r from-teal-800 to-teal-700 px-4 py-3 rounded-t-xl">
            <h2 className="text-lg font-bold text-white flex items-center gap-2">
              🏛️ Institutions
            </h2>
            <div className="flex space-x-2">
              <button
                onClick={() => handleEdit("Institution")}
                className="flex items-center justify-center px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition"
              >
                <FaEdit className="mr-1" /> Modifier
              </button>
              <button
                onClick={() => handleDelete("Institution")}
                className="flex items-center justify-center px-3 py-1.5 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition"
              >
                <FaTrash className="mr-1" /> Supprimer
              </button>
              <button
                onClick={() => handleAdd("Institution")}
                className="flex items-center justify-center px-3 py-1.5 bg-green-100 text-green-600 rounded-lg hover:bg-green-200 transition"
              >
                <FaPlus className="mr-1" /> Ajouter
              </button>
            </div>
          </div>

          {/* Body */}
          <div className="p-6 space-y-6">
            {/* Dropdown */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div>
                <Select
                  id="institutions"
                  name="institutions"
                  options={institutions.map((institution) => ({
                    value: institution._id,
                    label: String(institution.name),
                  }))}
                  onChange={handleSelectChangeInstitution}
                  placeholder="Sélectionner"
                  value={
                    selectedInstitution
                      ? {
                        value: selectedInstitution._id,
                        label: String(selectedInstitution.name),
                      }
                      : null
                  }
                  isClearable
                  menuPlacement="auto"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  filterOption={(option, inputValue) =>
                    option.label
                      .toLowerCase()
                      .startsWith(inputValue.toLowerCase())
                  }
                />
                {dropdownErrorInstitution && (
                  <p className="text-red-500 text-sm mt-2">
                    {dropdownErrorInstitution}
                  </p>
                )}
              </div>
            </div>
            {/* Input */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div>
                <input
                  type="text"
                  value={nouveauInstitution}
                  onChange={(e) => {
                    setNouveauInstitution(e.target.value);
                    setInputFieldsErrorInstitution("");
                  }}
                  className="mt-1 p-2 w-full border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
                  placeholder="Institution"
                />
                {inputFieldsErrorInstitution && (
                  <p className="text-red-500 text-sm mt-2">
                    {inputFieldsErrorInstitution}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {(checkGroupRecMensuelle || checkGroupAdmin) && (
        <div>
          <div className="rounded-xl shadow-md bg-white p-6 w-full mb-8">
            {/* Header */}
            <div className="flex items-center gap-3 mb-4">
              <span className="text-2xl animate-bounce">💾</span>
              <h2 className="text-xl font-bold text-gray-800">
                Générer les fichiers Excel
              </h2>
            </div>

            {/* Body */}
            <div className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition w-full border border-gray-200">
              <FichierExcel />
            </div>
          </div>

          {/* Section Nature de dépense */}
          <div className="bg-white rounded-xl shadow-md border border-gray-200 mb-8">
            {/* Header */}
            <div className="flex items-center justify-between bg-gradient-to-r from-indigo-700 to-indigo-600 px-4 py-3 rounded-t-xl">
              <h2 className="text-lg font-bold text-white flex items-center gap-2">
                🧾 Nature de dépense
              </h2>
              <div className="flex space-x-2">
                {/* Boutons d'action */}
                <button
                  onClick={() => handleEdit("Nature de dépense")}
                  className="flex items-center justify-center px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition"
                >
                  <FaEdit className="mr-1" /> Modifier
                </button>
                <button
                  onClick={() => handleDelete("Nature de dépense")}
                  className="flex items-center justify-center px-3 py-1.5 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition"
                >
                  <FaTrash className="mr-1" /> Supprimer
                </button>
                <button
                  onClick={() => handleAdd("Nature de dépense")}
                  className="flex items-center justify-center px-3 py-1.5 bg-green-100 text-green-600 rounded-lg hover:bg-green-200 transition"
                >
                  <FaPlus className="mr-1" /> Ajouter
                </button>
              </div>
            </div>

            {/* Contenu */}
            <div className="p-6 space-y-6">
              {/* Ligne 1 */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {/* Dropdown nature dépense */}
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-1 block">
                    Sélectionner une nature
                  </label>
                  <Select
                    id="natureDepenses"
                    name="natureDepenses"
                    options={natureDepenses.map((depense) => ({
                      value: depense._id,
                      label: String(depense.value),
                    }))}
                    onChange={handleSelectChange}
                    placeholder="Choisir..."
                    value={
                      selectedNatureDepense
                        ? {
                          value: selectedNatureDepense._id,
                          label: String(selectedNatureDepense.value),
                        }
                        : null
                    }
                    isClearable
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                  {dropdownError && (
                    <p className="text-red-500 text-sm mt-1">{dropdownError}</p>
                  )}
                </div>
              </div>

              {/* Ligne 2 */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {/* Input Nature */}
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-1 block">
                    Nature
                  </label>
                  <input
                    type="text"
                    value={value}
                    onChange={(e) => {
                      setValue(e.target.value);
                      setInputFieldsError("");
                    }}
                    className="p-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Ex: Transport"
                  />
                  {inputFieldsError && (
                    <p className="text-red-500 text-sm mt-1">
                      {inputFieldsError}
                    </p>
                  )}
                </div>

                {/* Input Compte */}
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-1 block">
                    Compte
                  </label>
                  <input
                    type="number"
                    value={compte}
                    onChange={(e) => {
                      setCompte(e.target.value);
                      setInputFieldsError("");
                    }}
                    className="p-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Ex: 12345"
                  />
                </div>
              </div>

              {/* Ligne 3 */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {/* Dropdown Catégorie */}
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-1 block">
                    Catégorie
                  </label>
                  <Select
                    id="categories"
                    name="categories"
                    options={categories.map((cat) => ({
                      value: cat._id,
                      label: String(cat.value),
                    }))}
                    onChange={(selectedOption) => {
                      setSelectedCategory(selectedOption);
                      setInputFieldsError("");
                    }}
                    placeholder="Choisir catégorie"
                    value={selectedCategory}
                    isClearable
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>

                {/* Dropdown Code Taxe */}
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-1 block">
                    Code taxe
                  </label>
                  <Select
                    id="codeTaxe"
                    name="codeTaxe"
                    options={codesTaxe.map((taxe) => ({
                      value: taxe._id,
                      label: String(taxe.value),
                    }))}
                    onChange={(selectedOption) => {
                      setSelectedCodeTaxe(selectedOption);
                      setInputFieldsError("");
                    }}
                    placeholder="Choisir code de taxe"
                    value={selectedCodeTaxe}
                    isClearable
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Section Centre de coût */}
          <div className="bg-white rounded-xl shadow-md border border-gray-200 mb-8 mt-8">
            {/* Header */}
            <div className="flex items-center justify-between bg-gradient-to-r from-indigo-700 to-indigo-600 px-4 py-3 rounded-t-xl">
              <h2 className="text-lg font-bold text-white flex items-center gap-2">
                🏢 Centre de coût
              </h2>
              <div className="flex space-x-2">
                {/* Boutons d’action */}
                <button
                  onClick={() => handleEdit("Centre de cout")}
                  className="flex items-center justify-center px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition"
                >
                  <FaEdit className="mr-1" /> Modifier
                </button>
                <button
                  onClick={() => handleDelete("Centre de cout")}
                  className="flex items-center justify-center px-3 py-1.5 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition"
                >
                  <FaTrash className="mr-1" /> Supprimer
                </button>
                <button
                  onClick={() => handleAdd("Centre de cout")}
                  className="flex items-center justify-center px-3 py-1.5 bg-green-100 text-green-600 rounded-lg hover:bg-green-200 transition"
                >
                  <FaPlus className="mr-1" /> Ajouter
                </button>
              </div>
            </div>

            {/* Contenu */}
            <div className="p-6 space-y-6">
              {/* Dropdown sélection centre de coût */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-1 block">
                    Sélectionner un centre de coût
                  </label>
                  <Select
                    id="centreCout"
                    name="centreCout"
                    options={centreCouts.map((centreCout) => ({
                      value: centreCout._id,
                      label: String(centreCout.value),
                    }))}
                    onChange={(selectedOption) => {
                      handleSelectChangeCentreCout({
                        target: {
                          value: selectedOption ? selectedOption.value : "",
                        },
                      });
                    }}
                    placeholder="Choisir..."
                    value={
                      selectedCentreCouts
                        ? {
                          value: selectedCentreCouts._id,
                          label: String(selectedCentreCouts.value),
                        }
                        : null
                    }
                    isClearable
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                  {dropdownErrorCout && (
                    <p className="text-red-500 text-sm mt-1">
                      {dropdownErrorCout}
                    </p>
                  )}
                </div>
              </div>

              {/* Input valeur */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-1 block">
                    Valeur
                  </label>
                  <input
                    type="number"
                    value={nouveaucentreCouts}
                    onChange={(e) => {
                      setNouveauCentreCout(e.target.value);
                      setInputFieldsErrorCout("");
                    }}
                    className="p-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                    placeholder="Ex: 45678"
                  />
                  {inputFieldsErrorCout && (
                    <p className="text-red-500 text-sm mt-1">
                      {inputFieldsErrorCout}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Section Fonds */}
          <div className="bg-white rounded-xl shadow-md border border-gray-200 mb-8 mt-8">
            {/* Header */}
            <div className="flex items-center justify-between bg-gradient-to-r from-indigo-700 to-indigo-600 px-4 py-3 rounded-t-xl">
              <h2 className="text-lg font-bold text-white flex items-center gap-2">
                💰 Fonds
              </h2>
              <div className="flex space-x-2">
                {/* Boutons d’action */}
                <button
                  onClick={() => handleEdit("Fund")}
                  className="flex items-center justify-center px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition"
                >
                  <FaEdit className="mr-1" /> Modifier
                </button>
                <button
                  onClick={() => handleDelete("Fund")}
                  className="flex items-center justify-center px-3 py-1.5 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition"
                >
                  <FaTrash className="mr-1" /> Supprimer
                </button>
                <button
                  onClick={() => handleAdd("Fund")}
                  className="flex items-center justify-center px-3 py-1.5 bg-green-100 text-green-600 rounded-lg hover:bg-green-200 transition"
                >
                  <FaPlus className="mr-1" /> Ajouter
                </button>
              </div>
            </div>

            {/* Contenu */}
            <div className="p-6 space-y-6">
              {/* Dropdown sélection fonds */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-1 block">
                    Sélectionner un fonds
                  </label>
                  <Select
                    id="funds"
                    name="funds"
                    options={funds.map((fund) => ({
                      value: fund._id,
                      label: String(fund.value),
                    }))}
                    onChange={(selectedOption) => {
                      handleSelectChangeFunds({
                        target: {
                          value: selectedOption ? selectedOption.value : "",
                        },
                      });
                    }}
                    placeholder="Choisir..."
                    value={
                      selectedFunds
                        ? {
                          value: selectedFunds._id,
                          label: String(selectedFunds.value),
                        }
                        : null
                    }
                    isClearable
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                  {dropdownErrorFunds && (
                    <p className="text-red-500 text-sm mt-1">
                      {dropdownErrorFunds}
                    </p>
                  )}
                </div>
              </div>

              {/* Input valeur */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-1 block">
                    Valeur
                  </label>
                  <input
                    type="number"
                    value={nouveauFunds}
                    onChange={(e) => {
                      setNouveauFunds(e.target.value);
                      setInputFieldsErrorFunds("");
                    }}
                    className="p-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder="Ex: 12345"
                  />
                  {inputFieldsErrorFunds && (
                    <p className="text-red-500 text-sm mt-1">
                      {inputFieldsErrorFunds}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-xl shadow-md bg-white p-6 w-full">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <span className="text-2xl">🚗</span>
                <h2 className="text-xl font-bold text-gray-800">
                  Taux de kilométrage
                </h2>
              </div>
              <button
                onClick={handleAddTable}
                className="px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg shadow hover:opacity-90 transition"
              >
                + Ajouter
              </button>
            </div>

            {/* Table */}
            <div className="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
              <table className="w-full table-auto">
                <thead className="bg-gradient-to-r from-gray-100 to-gray-200 text-gray-700">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold">Taux</th>
                    <th className="px-4 py-3 text-left font-semibold">Début</th>
                    <th className="px-4 py-3 text-left font-semibold">Fin</th>
                    <th className="px-4 py-3 text-left font-semibold">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[...taux]
                    .sort(
                      (a, b) => new Date(b.Datedebut) - new Date(a.Datedebut)
                    )
                    .map((t) => (
                      <tr
                        key={t._id}
                        className="hover:bg-gray-50 transition duration-200"
                      >
                        {editId === t._id ? (
                          <>
                            <td className="px-4 py-2">
                              <input
                                type="text"
                                name="value"
                                value={editData.value}
                                onChange={handleChange}
                                className="border rounded-lg px-3 py-2 w-full focus:ring focus:ring-blue-300"
                              />
                            </td>
                            <td className="px-4 py-2">
                              <input
                                type="date"
                                name="Datedebut"
                                value={editData.Datedebut}
                                onChange={handleChange}
                                className="border rounded-lg px-3 py-2 w-full focus:ring focus:ring-blue-300"
                              />
                            </td>
                            <td className="px-4 py-2">
                              <input
                                type="date"
                                name="DatedeFin"
                                value={editData.DatedeFin}
                                onChange={handleChange}
                                className="border rounded-lg px-3 py-2 w-full focus:ring focus:ring-blue-300"
                              />
                            </td>
                            <td className="px-4 py-2 flex gap-4">
                              <button
                                onClick={() => handleSave(t._id)}
                                className="text-green-600 font-semibold hover:underline"
                              >
                                Sauvegarder
                              </button>
                              <button
                                onClick={() => handleCancel(t._id)}
                                className="text-gray-600 font-semibold hover:underline"
                              >
                                Annuler
                              </button>
                            </td>
                          </>
                        ) : (
                          <>
                            <td className="px-4 py-3">{t.value}</td>
                            <td className="px-4 py-3">
                              {t.Datedebut
                                ? new Date(t.Datedebut)
                                  .toISOString()
                                  .split("T")[0]
                                : ""}
                            </td>
                            <td className="px-4 py-3">
                              {t.DatedeFin
                                ? new Date(t.DatedeFin)
                                  .toISOString()
                                  .split("T")[0]
                                : "En cours"}
                            </td>
                            <td className="px-4 py-3 flex gap-6">
                              <button
                                onClick={() => handleEditTable(t)}
                                className="text-indigo-600 font-semibold hover:underline"
                              >
                                Modifier
                              </button>
                              <button
                                onClick={() => handleDeleteTable(t._id)}
                                className="text-red-600 font-semibold hover:underline"
                              >
                                Supprimer
                              </button>
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>


        </div>
      )}
      {successMessage && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <div
            className={`flex items-center space-x-3 px-5 py-4 bg-white ${couleur} rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce`}
          >
            <CheckCircleIcon
              className={`h-8 w-8 ${couleur} animate-pulse`}
            />
            <span className="text-lg font-semibold">{successMessage}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default GestionDonneeFinance;
